import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Footer from './footer';
import Header from './header/header';

const Layout = ({ children, pathname }) => {
    useEffect(() => {
        // Enhance accessibility focus styling for keyboard users
        const handleKeyDown = ( ) => {
            document.body.classList.add('using-keyboard');
        }
        const handleMouseDown = ( ) => {
            document.body.classList.remove('using-keyboard');
        }
            
        document.body.addEventListener('keydown', handleKeyDown);

        document.body.addEventListener('mousedown', handleMouseDown);
        
        return () => {
            document.body.removeEventListener('keydown', handleKeyDown);
            document.body.removeEventListener('mousedown', handleKeyDown);
        };
    }, []);

    return (
        <>
            <Header
                siteTitle={ `PaycheckCity` }
                pathname={ pathname }
                id="top"
            />
            <main id="main-content">{children}</main>
            <Footer pathname={ pathname }/>
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
